import React, {useContext} from 'react';
import {Box, InputAdornment, TextField, Typography, IconButton} from '@mui/material';
import {useWidgetLabelChanged} from '@assets/pages/Widget/WidgetLabelChangedProvider';
import IconSendOutline from '@assets/components/ResouceIcon/IconSendOutline';
import {FloatButtonContext} from '@assets/contexts/floatButtonContext';
import {cleanString} from '@assets/helpers/blockXSSAttack';

export default function SubscribeNewsletterPopup({campaign, i18nCampaign, sx}) {
  const {isLabelChanged} = useWidgetLabelChanged();
  const {i18n} = useContext(FloatButtonContext);
  const message = isLabelChanged
    ? cleanString(campaign?.message?.content)
    : i18nCampaign('message', campaign?.id) || campaign?.message?.content;

  return (
    <div className="Avada-SubscribeNewsletter__Content">
      <div className="AvadaFaqs-MUI-WPMessageTextFont">
        <div style={{textAlign: 'left', marginRight: '20px'}}>
          <Typography
            variant="div"
            style={{fontSize: '14px', color: '#000000', position: 'relative'}}
          >
            <span
              className="Avada-PopupV2__Message"
              dangerouslySetInnerHTML={{
                __html: message?.replaceAll('\n', '<br/>').replaceAll('\\n', '<br/>')
              }}
            />
          </Typography>
        </div>

        <Box mt={1.5}>
          <TextField
            fullWidth
            placeholder={i18n('Click to reply')}
            variant="filled"
            sx={{'& .MuiFilledInput-root': sx.inputRoot, '& .MuiFilledInput-input': sx.input}}
            slotProps={{
              input: {
                disableUnderline: true,
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton sx={sx.iconButton}>
                      <IconSendOutline fill="#cccccc" />
                    </IconButton>
                  </InputAdornment>
                )
              }
            }}
          />
        </Box>
      </div>
    </div>
  );
}
